<template>
	<div>
		<h3 v-if="!editing && dragItems.length > 0" v-html="title" class="list-title" />
		<draggable
			v-model="dragItems"
			tag="ul"
			:class="{ requirements: true, no: !positive, editing: editing }"
			:disabled="!editing || dragItems.length <= 1"
			item-key="index">
			<template #item="{ element: item, index }">
				<li :key="index">
					<span :class="{ wrap: true, drag: dragItems.length > 1 && editing }"
						><Icon type="thumbs-up" class="icon" :colour="positive ? '#679DA2' : '#a26c67'" /> {{ item }}</span
					>
					<span class="delete" @click="deleteItem(item)" title="Delete" v-if="editing">❌</span>
				</li>
			</template>
		</draggable>
	</div>
</template>

<script>
import Icon from "./BaseIcon.vue";
import draggable from "vuedraggable";

export default {
	name: "RequirementsList",
	emits: ["update:items", "delete"],
	components: { Icon, draggable },
	props: {
		items: {
			type: Array,
			required: true,
		},
		positive: {
			type: Boolean,
			default: true,
		},
		editing: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		title() {
			return this.positive ? "What we're looking for" : "What we're not looking for";
		},
		dragItems: {
			get() {
				return this.items;
			},
			set(newValue) {
				this.$emit("update:items", newValue);
			},
		},
	},
	methods: {
		deleteItem(item) {
			const listType = this.positive ? "wants" : "bads";
			this.$emit("delete", listType, item);
		},
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";
.list-title {
	margin: 20px 0 10px;
	padding: 0;
	font-size: 17px;
}
.requirements {
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		padding: 0 0 0 24px;
		margin: 0 0 8px;
		position: relative;

		.icon {
			width: 15px;
			position: absolute;
			left: 3px;
			top: 3px;
		}

		.wrap {
			display: inline-block;
			&.drag {
				cursor: move;
				.icon {
					cursor: move;
				}
			}
		}

		.delete {
			cursor: pointer;
			vertical-align: middle;
			font-size: 0.5em;
			display: inline-block;
			padding-left: 8px;
		}
	}

	&.editing {
		margin: 15px 0 0;
		li {
			font-size: 14px;
			padding: 0 20px 0 22px;
			margin-bottom: 12px;
			.icon {
				width: 12px;
			}
			.delete {
				position: absolute;
				top: 6px;
			}
		}
	}

	&.no {
		li {
			.icon {
				transform: rotate(180deg);
				top: 5px;
			}
		}
	}
}
</style>